import { postGateway } from '@/request';
import bus from '@/utils/bus.js';

export default {
  data() {
    return {
      form: {
        phone: '',
        code: (this.$isUk ? '+44' : '+353'),
        verCode: '', // 手机验证码
        password: '', // 密码
        email: '', // 邮箱
      },
      agree: false,
      canGetCode: true,
      sendPhonecode: 'Send Verification Code',
      num: 0,
      secondSend: 0,
      loginMethod: 'password', // 登录方式：sms 或 password
      showPassword: false, // 是否显示密码
      showCloudflare: false, // 是否显示Cloudflare验证
      showAgreeAnimation: false
    }
  },
  computed: {
    canLogin() {
      if (!this.agree) return false;
      
      if (this.loginMethod === 'password') {
        if (!this.form.email.trim()) return false;
        return this.form.password.trim() !== '';
      } else {
        if (!this.form.phone.trim()) return false;
        return this.canGetCode;
      }
    }
  },
  methods: {
    // 重置Cloudflare验证
    resetCode() {
      if (this.$refs.cloudflare) {
        this.$refs.cloudflare.reSetTurnSite();
      }
    },
    
    // Cloudflare token接收回调
    onTokenReceived(token) {
      if (token) {
        this.showCloudflare = false;
        this.sendcodeMsg(token);
      }
    },
    
    // 处理登录按钮点击
    handleLogin() {
      if (this.loginMethod === 'sms') {
        this.showCaptcha();
      } else {
        this.loginWithPassword();
      }
    },
    
    // 密码登录
    async loginWithPassword() {
      if (!this.form.email.trim()) {
        this.$message({
          message: 'Please enter email or phone number',
          type: 'warning',
          offset: 50
        });
        return;
      }
      if (!this.form.password.trim()) {
        this.$message({
          message: 'Please enter password',
          type: 'warning',
          offset: 50
        });
        return;
      }
      if (!this.agree) {
        this.$message({
          message: 'Please agree the policy',
          type: 'warning',
          offset: 50
        });
        this.showAgreeAnimation = true;
        setTimeout(() => {
          this.showAgreeAnimation = false;
        }, 1000);
        return;
      }

      this.setLoginLoading(true);
      
      try {
        // 使用正确的密码登录接口和参数
        const resp = await postGateway({
          url: '/login',
          method: 'POST',
          data: {
            userName: this.form.email, // 使用统一的账号输入
            password: this.$encryptByPublicKey(this.form.password), // 密码需要加密
            client: 'webApi',
            captcha: ''
          }
        });

        this.setLoginLoading(false);
        if (resp.data.token) {
          this.handleLoginSuccess(resp.data);
        }
        console.log(resp, '密码登录回调');
      } catch (err) {
        this.$message.error(err.msg || 'Login failed');
        this.setLoginLoading(false);
      }
    },
    
    // 显示验证滑块
    async showCaptcha() {
      // 基础验证
      if (!this.form.phone.trim()) {
        this.$message({
          message: 'Please enter phone number',
          type: 'warning',
          offset: 50
        });
        return;
      }
      if (this.form.phone.indexOf(44) === 0) {
        this.$message({
          message: "Without the '44' country code.",
          type: "warning",
          offset: 50
        });
        return;
      }

      // 校验手机号开头
      let phoneCode = this.form.code.replace('+', '');
      if (this.form.phone.indexOf(phoneCode) === 0) {
        this.$message({
          message: "Please check phone number width '" + phoneCode + "'",
          type: "warning",
        });
        return;
      }

      if (!this.agree) {
        this.$message({
          message: 'Please agree the policy',
          type: 'warning',
          offset: 50
        });
        this.showAgreeAnimation = true;
        setTimeout(() => {
          this.showAgreeAnimation = false;
        }, 1000);
        return;
      }

      // 如果正在倒计时，显示友好提示
      if (!this.canGetCode) {
        this.$message({
          message: `Please wait ${this.num} seconds before requesting again`,
          type: 'info',
          offset: 50
        });
        return;
      }

      // 直接显示Cloudflare验证弹层
      this.showCloudflare = true;
      // 不需要手动调用 getToken()，因为验证完成后会自动触发 token-received 事件
    },
    
    // 校验手机号是否重复国家代码（仅针对 +44 和 +353）
    validatePhoneNumber() {
      const phoneNumber = this.form.phone.trim();
      
      // 只处理 +44 和 +353 的情况
      if (this.form.code === '+44' && phoneNumber.startsWith('44')) {
        this.$message({
          message: "Please remove the country code '44' from the phone number",
          type: 'warning',
          offset: 50
        });
        return false;
      }
      
      if (this.form.code === '+353' && phoneNumber.startsWith('353')) {
        this.$message({
          message: "Please remove the country code '353' from the phone number",
          type: 'warning',
          offset: 50
        });
        return false;
      }
      
      return true;
    },
    
    // 发送手机验证码
    async sendcodeMsg(captchaVerification) {
      if (!captchaVerification) {
        return;
      }

      // 校验手机号格式
      if (!this.validatePhoneNumber()) {
        return;
      }

      this.setLoading(true);
      let url = `/customer/atClient/smsSend`;
      if (this.secondSend > 0) {
        url = `/customer/atClient/smsSendTextlocal`;
      }
      
      try {
        const res = await postGateway({
          url: url,
          data: {
            phone: this.form.email.trim(),
            captchaType: 'register',
            captchaVerification
          }
        });

        this.setLoading(false);
        if (res.code == 200) {
          this.handleSmsSuccess();
          this.secondSend++;
          this.$message({
            message: 'Verification sent successfully',
            type: 'success',
            offset: 50
          });
          // 只有发送成功才开始倒计时
          this.startCountdown();
        }
        this.resetCode();
      } catch (err) {
        this.setLoading(false);
        console.log(err, '发送短信失败');
        this.$message({
          message: 'You have reached login attempt limit. Please try again in a few hours',
          type: 'error',
          offset: 50
        });
        this.resetCode();
        // 发送失败不开始倒计时
      }
    },
    
    // 开始倒计时
    startCountdown() {
      this.num = 60;
      this.timer2 = setInterval(() => {
        this.num--;
        this.canGetCode = false;
        this.sendPhonecode = 'After ' + this.num + ' seconds retry';
        if (this.num == 0) {
          this.sendPhonecode = 'Resend Code';
          this.canGetCode = true;
          clearInterval(this.timer2);
        }
      }, 1000);
    },
    
    // 处理登录成功
    handleLoginSuccess(data) {
      let { token, refreshToken, clientId } = data;
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('clientId', clientId);
      localStorage.setItem("aeClient", clientId);
      bus.$emit('login'); // 通知header登陆了
      
      // 子组件可以重写此方法
      if (this.onLoginSuccess) {
        this.onLoginSuccess(data);
      }
    },
    
    // 处理短信发送成功
    handleSmsSuccess() {
      // 子组件可以重写此方法
      if (this.onSmsSuccess) {
        this.onSmsSuccess();
      }
    },
    
    // 设置加载状态 - 子组件需要实现
    setLoading() {
      // 子组件需要重写此方法
      console.warn('setLoading method should be implemented by child component');
    },
    
    // 设置登录加载状态 - 子组件需要实现
    setLoginLoading() {
      // 子组件需要重写此方法
      console.warn('setLoginLoading method should be implemented by child component');
    }
  }
};
